import { Stack } from '../../../../components/Stack';
import { Heading, Paragraph } from '../../../../components/Typography';
import { WebsheetTemplateProps } from '../../../../types/websheet';
import { ONE_CLICK_TC_EMPTY_BODY, ONE_CLICK_TC_TITLE } from './constants';

const componentName = 'c-OneClickTermsConditionsE';

type OneClickTcText = {
  one_click_tc_text?: string;
};

type Props = WebsheetTemplateProps<OneClickTcText>;

/**
 * Portal preview of the one-click transfer Terms & Conditions, styled after
 * the iOS system sheet. The real screen is rendered natively by iOS from the
 * carrier's `one_click_tc_text`; the websheet never links to this version key.
 *
 * Reads only `text.one_click_tc_text`: the portal preview store deep-merges
 * every step's copy into one object, so websheet keys such as `title` and
 * `content` are present but must be ignored here.
 */
export const OneClickTermsConditionsE = ({ text }: Props) => {
  const body =
    typeof text?.one_click_tc_text === 'string' ? text.one_click_tc_text : '';

  const renderBody = () => {
    if (body.trim().length === 0) {
      return (
        <Paragraph size="sm" color="light">
          {ONE_CLICK_TC_EMPTY_BODY}
        </Paragraph>
      );
    }

    return (
      <Paragraph
        size="sm"
        color="strong"
        className="whitespace-pre-wrap break-words"
      >
        {body}
      </Paragraph>
    );
  };

  return (
    <Stack
      tag="main"
      direction="column"
      gap={6}
      className={`${componentName} bg-white px-6 pt-10 pb-8`}
    >
      <Heading level={1} className="text-center">
        {ONE_CLICK_TC_TITLE}
      </Heading>
      {renderBody()}
    </Stack>
  );
};
